var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { memo } from 'react';
import classnames from 'classnames';
import moduleStyles from './typography.module.scss';
var Typography = function (_a) {
    var semanticTag = _a.semanticTag, visualAppearance = _a.visualAppearance, children = _a.children, className = _a.className, style = _a.style, props = __rest(_a, ["semanticTag", "visualAppearance", "children", "className", "style"]);
    var Tag = semanticTag;
    return (React.createElement(Tag, __assign({ className: classnames(moduleStyles[visualAppearance], className), style: style }, props), children));
};
export default memo(Typography);
